import Modal from '../../mini/Modal'
import React from 'react'
import { H2, P3 } from '../../styled/typography/typography'
import Button from '../../mini/Button'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { ModalStyles } from './styled'

const InvalidLinkModal = ({ invalidated }) => {
  const dispatch = useDispatch()

  return (
    <Modal
      width={472}
      height={264}
      topPx={345}
      background={'transparent'}
      opacity={'1'}
      boxShadow={'0 0 30px 0 rgba(0,0,0,0.07)'}
    >
      <ModalStyles>
        <div className="center">
          <H2 style={{ marginBottom: '26px' }}>This link is no longer valid.</H2>
          {!invalidated &&
            <P3>This link has already been used to create an account.</P3>
          }
          <P3 style={{ marginBottom: '26px' }}>Try signing in or contact your school administration for further help.</P3>
          <Button
            text="Go to Sign In"
            className="quest-btn btn-a go uncap active"
            onClick={() => dispatch(push('/'))}/>
        </div>
      </ModalStyles>
    </Modal>
  )
}

export default InvalidLinkModal
